import { get } from 'lodash-es';
import { isPickupType } from 'site-modules/shared/utils/is-pickup-type';

/**
 * Checks inventory bodyType & returns cabType for 'Pickup' listing
 * @param  {Object} styleInfo
 * @return {string}
 */
export function getCabType(styleInfo) {
  let cabType = '';
  const isPickup = isPickupType(get(styleInfo, 'bodyType', ''));
  const vehicleManufacturerCabType = get(styleInfo, 'manufacturerCabType', '');
  const vehicleStyle = get(styleInfo, 'vehicleStyle', '');

  if (isPickup) {
    const vehicleCabType = vehicleStyle && vehicleStyle.replace(/(pickup)$/i, '').trim(); // remove trailing 'Pickup' string from vehicleStyle
    cabType = vehicleManufacturerCabType || vehicleCabType;
  }

  return cabType;
}

export function getNonPickupVehicleStyle(styleInfo) {
  if (isPickupType(get(styleInfo, 'bodyType', ''))) {
    return '';
  }

  return get(styleInfo, 'vehicleStyle', '').trim();
}
